export const api_key = "CNCPaIxRn39Rlp7NlZ6y";
export const scan_sdk_api_key = "CNCPy0WuaMn4ld8g5oTl";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-one-int-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-one.carenow.healthcare");

export const cndWrapperURL = (url = "") =>
  new URL(url, "https://vc.cloudcayr.careplix.com");

export const cndURL = (url = "") =>
  new URL(url, "https://api-int-prod.carenowdoc.com");
